import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@shared-utils/ui";
import { Tooltip, TooltipContent } from "@shared-components/shadcn/tooltip";
import { TooltipTrigger } from "@radix-ui/react-tooltip";
import { CircleHelp } from "lucide-react";

const labelVariants = cva(
  "text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
      helpText?: string;
      required?: boolean;
    }
>(({ className, helpText, required, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  >
    {props.children}
    {required && <span className="ml-0.5">{"*"}</span>}
    {helpText && (
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <CircleHelp
            className="ml-1 inline relative -top-0.5 stroke-muted-foreground"
            size={14}
          />
        </TooltipTrigger>
        <TooltipContent className="p-2 max-w-[200px]">
          {helpText}
        </TooltipContent>
      </Tooltip>
    )}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
